import { DisputeDto } from "@merchant_api/models/dispute-dto";

export class DisputeState {
    loading = false;
    error = null;
    record: DisputeDto = null;
}
